(function () {
  if (!document.body) return;

  if (!document.querySelector(".rr-progress")) {
    var progress = document.createElement("div");
    progress.className = "rr-progress";
    document.body.appendChild(progress);
  }

  var progressBar = document.querySelector(".rr-progress");
  var heroSections = document.querySelectorAll(".rr-hero[data-parallax='true']");
  var productCards = document.querySelectorAll("product-card");

  var revealCards = function () {
    if (!("IntersectionObserver" in window)) {
      productCards.forEach(function (card) {
        card.classList.add("is-revealed");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    productCards.forEach(function (card) {
      observer.observe(card);
    });
  };

  var updateScrollFx = function () {
    var doc = document.documentElement;
    var scrollRange = doc.scrollHeight - window.innerHeight;
    var progress = scrollRange > 0 ? window.scrollY / scrollRange : 0;

    if (progressBar) {
      progressBar.style.transform = "scaleX(" + Math.max(0, Math.min(1, progress)) + ")";
    }

    heroSections.forEach(function (section) {
      var media = section.querySelector(".rr-hero__video, .rr-hero__image");
      var grid = section.querySelector(".rr-hero__grid");
      var rect = section.getBoundingClientRect();
      var midpoint = window.innerHeight / 2;
      var delta = (rect.top + rect.height / 2 - midpoint) / window.innerHeight;

      if (media) {
        media.style.transform = "scale(1.05) translate3d(0," + delta * -18 + "px,0)";
      }

      if (grid) {
        grid.style.transform = "translate3d(0," + delta * -26 + "px,0)";
      }
    });
  };

  revealCards();
  updateScrollFx();

  window.addEventListener("scroll", updateScrollFx, { passive: true });
  window.addEventListener("resize", updateScrollFx);
})();
